import { render, staticRenderFns } from "./VideoN.vue?vue&type=template&id=61cd637e&scoped=true"
import script from "./VideoN.vue?vue&type=script&lang=js"
export * from "./VideoN.vue?vue&type=script&lang=js"
import style0 from "./VideoN.vue?vue&type=style&index=0&id=61cd637e&prod&scoped=true&lang=scss"
import style1 from "./VideoN.vue?vue&type=style&index=1&id=61cd637e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd637e",
  null
  
)

export default component.exports